module.exports = __webpack_public_path__ + "img/NarminOsman-Afsana.bc3c3706.jpg";